// @ts-strict-ignore
import {MenuType} from 'common/query-builder/query-block/multi-metrics-menu/types';
import {Entry, MetricEntry} from 'common/query-builder/query-entry-section/types';
import {getNewEntry as getNewFunnelEntry} from 'common/query-builder/query-entry-section/row-types/metric-entry/metrics/funnels/utils';
import {getNewEntry as getNewRetentionEntry} from 'common/query-builder/query-entry-section/row-types/metric-entry/metrics/retention/utils';
import {getNewInlineEntry} from 'common/query-builder/query-entry-section/row-types/formula-entry/utils';
import {MetricType} from 'common/types/reports/bookmark';
import * as BookmarkTypes from 'common/types/reports/bookmark';

/**
 * Handles the Create metric flow from the metrics menu
 */
export function getNewMetricEntry({menuType, entries}: {menuType: MenuType; entries: Entry[]}) {
  if (menuType === MenuType.Funnel) {
    return getNewFunnelEntry({isExpanded: true, firstClassMetricsEnabled: true});
  } else if (menuType === MenuType.Retention) {
    return getNewRetentionEntry({isExpanded: true, type: MetricType.Retention, firstClassMetricsEnabled: true});
  } else if (menuType === MenuType.Formula) {
    const item = getNewInlineEntry(entries);
    const formulaMetric: MetricEntry = {
      type: BookmarkTypes.TopLevelMetricType.NewFormulaEntry,
      name: item.name,
      definition: item.definition,
      behavior: null,
      measurement: null,
    };

    return formulaMetric;
  }

  throw new Error(`Unsupported metric type: ${menuType}`);
}
